"use client";

// packages/eden-headings/src/components/H3.jsx
import styled from "styled-components";
import { jsx } from "react/jsx-runtime";
var H3Styled = styled.h3`
  margin: 0;
  font: normal normal 700 calc(20rem / 16) / 1.2 var(--unity-font-family-sans);
`;
var H3 = ({ children, renderAs, ...props }) => /* @__PURE__ */ jsx(H3Styled, { as: renderAs, ...props, children });
H3.displayName = "H3";
var H3_default = H3;
export {
  H3_default as default
};
